import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import s from "./detailStatus.scss";
import t from "Utils/translation";

class DetailStatus extends React.Component {
  render() {
    const { className, status } = this.props;

    return (
      <div className={cx(className, s.detailStatus, { [s[status]]: true })} />
      /*
      <div className={cx(className, s.detailStatus, { [s[status]]: true })}>
        {t(`detail.status.${status}`)}
      </div>*/
    );
  }
}

export default DetailStatus;
